import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Address} from '@spartacus/core/src/model/address.model';
import {AddressParams, AddressUsage} from '@app/model/order/dcp-order-entry.model';
import {AttachedDocumentsModel} from '@app/model/attached-documents.model';
import {PaymentType} from '@spartacus/cart/base/root';

@Component({
  selector: 'dcp-cart-header-information',
  templateUrl: './cart-header-information.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartHeaderInformationComponent {

  @Input() addresses: Address[];
  @Input() paymentType: PaymentType;
  @Input() documents: AttachedDocumentsModel[];
  @Input() isCurrentUserIndividual: boolean;
  @Input() cartIsLoading: boolean = false;
  addressUsage = AddressUsage;
  addressParams = AddressParams;

  getInfo(type: string): Address {
    const item = this.addresses.find(item => item.addressUsage === type);
    return !!item ? item : {};
  }
}
